var React = require('react');

function Vials (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M128 304a48 48 0 0 0 96 0V160h-96zm288-144v144a48 48 0 0 0 96 0V160z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M360 64h24v240a80 80 0 0 0 160 0V64h24a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8H360a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zm72 0h64v240a32 32 0 0 1-64 0zm192 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h608a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM72 64h24v240a80 80 0 0 0 160 0V64h24a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8H72a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zm72 0h64v240a32 32 0 0 1-64 0z","className":"fa-primary","key":2})]);
}

Vials.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Vials;

Vials.default = Vials;
